// extracted by mini-css-extract-plugin
module.exports = {"widget":"DashboardWidget_widget__19MSS","loading":"DashboardWidget_loading__7wfcn"};